import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, useIntl } from 'react-intl';

import { promoShape } from '@bibliocommons/bc-prop-types';

import Heading from 'app/components/shared/Heading';
import cardShape from 'app/shapes/cardShape';
import PromosInfoModal from 'app/components/bibs/shared/PromosInfoModal';
import PromoCard from './PromoCard';

import './PromoCards.scss';

const PromoCards = ({
  cmsUrl,
  hasDiscoveryLinks,
  isDebugEnabled,
  promoCards,
  promosById,
  trackCardImageClick,
  trackCardImpression,
  trackCardTitleClick,
  trackCardTypeClick
}) => {
  const intl = useIntl();

  const infoScreenReaderLabel = intl.formatMessage({
    defaultMessage: 'About more from the library',
    id: 'about_more_from_the_library'
  });

  return (
    <section className="cp-promo-cards">
      <Heading className="cp-promo-cards__title" size="moderate" tagName="h2" variant>
        <FormattedMessage id="more_cards_link_text" />
        <PromosInfoModal className="cp-promo-cards__info" infoScreenReaderLabel={infoScreenReaderLabel} />
      </Heading>

      <ul className="row cp-promo-cards__row">
        {promoCards?.map((promoCard, index) => {
          const cardId = promoCard.get('id');
          const position = index + 1;
          const promo = promosById.get(String(cardId));

          return (
            <li className="col-sm-6 col-md-3 cp-promo-cards__item" key={cardId}>
              <PromoCard
                cmsUrl={cmsUrl}
                hasDiscoveryLink={hasDiscoveryLinks}
                isDebugEnabled={isDebugEnabled}
                promo={promo}
                promoCard={promoCard}
                trackImageClick={() => {
                  trackCardImageClick({
                    card: promoCard,
                    position
                  });
                }}
                trackImpression={() => {
                  trackCardImpression({
                    card: promoCard,
                    position
                  });
                }}
                trackTitleClick={linkText =>
                  trackCardTitleClick({
                    card: promoCard,
                    linkText,
                    position
                  })}
                trackTypeClick={linkText => {
                  trackCardTypeClick({
                    card: promoCard,
                    linkText,
                    position
                  });
                }}
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
};

PromoCards.propTypes = {
  cmsUrl: PropTypes.string.isRequired,
  hasDiscoveryLinks: PropTypes.bool.isRequired,
  isDebugEnabled: PropTypes.bool.isRequired,
  promoCards: ImmutablePropTypes.listOf(cardShape).isRequired,
  promosById: ImmutablePropTypes.mapOf(promoShape, PropTypes.string),
  trackCardImageClick: PropTypes.func.isRequired,
  trackCardImpression: PropTypes.func.isRequired,
  trackCardTitleClick: PropTypes.func.isRequired,
  trackCardTypeClick: PropTypes.func.isRequired
};

export default PromoCards;
